import React from "react";
import Button from "../Button";
import Icon from "../../common/Icon";
import AddEditModalHeader from "../../pages/App/Programs/popups/AddEditTask";
import { ButtonSpacer } from "../Button/styles";
import {
  ModalContainer,
  ModalBackground,
  ModalContent,
  ModalTitle,
  ModalActions,
  IconWrapper,
} from "./styles";

function Modal({
  children,
  title,
  actions,
  onClose,
  onOutsideClick,
  fixedWidth,
  width,
  minWidth,
  maxWidth,
  isWidth,
  isHeight,
  noPadding,
  paddingBottom,
  className,
  actionClass,
  boardView,
  setModalrespon,
  isTask,
  isButtonCenter,
  setIconStyle,
  isMeeting,
  isNotRound,
  variant,
  isAddParticipants,
  isModalStyle,
  hideBorder,
  isHideIcon,
  isMarginRight,
  isHeighCalc,
  isMain,
  isCreate,
  isAddCreate,
}) {
  const isAddEditHeader =
    React.isValidElement(title) && title.type === AddEditModalHeader;

  return (
    <ModalContainer noPadding={noPadding} paddingBottom={paddingBottom}>
      <ModalBackground
        onClick={() => {
          if (onOutsideClick) {
            onOutsideClick();
          } else if (onClose) {
            onClose();
          }
        }}
        isHeighCalc={isHeighCalc}
        isMain={isMain}
        isCreate={isCreate}
        isAddCreate={isAddCreate}
      >
        <ModalContent
          isWidth={isWidth}
          isMain={isMain}
          setModalrespon={setModalrespon}
          className={className}
          isButtonCenter={isButtonCenter}
          onClick={(e) => {
            e.stopPropagation();
          }}
          fixedWidth={fixedWidth}
          width={width}
          minWidth={minWidth}
          maxWidth={maxWidth}
          isHeight={isHeight}
          noPadding={noPadding}
          paddingBottom={paddingBottom}
          boardView
          isMeeting={isMeeting}
        >
          <ModalTitle
            hideBorder={hideBorder}
            isModalStyle={isModalStyle}
            isMeeting={isMeeting}
          >
            {onClose && !isHideIcon && (
              <IconWrapper
                setIconStyle={setIconStyle}
                onClick={() => {
                  onClose();
                }}
              >
                <Icon type="cross" size="12" color="#252421" />
              </IconWrapper>
            )}
            <span>{title}</span>
          </ModalTitle>

          <div style={{ flexGrow: 1 }}>{children}</div>

          {actions && (
            <ModalActions
              isModalStyle={isModalStyle}
              className={actionClass}
              isMeeting={isMeeting}
              isButtonCenter={isButtonCenter}
              isAddParticipants={isAddParticipants}
              isMain={isMain}
              isCreate={isCreate}
              isAddCreate={isAddCreate}
            >
              {actions.map((action) => {
                return (
                  <>
                    <Button
                      isMarginRight={isMarginRight}
                      isModalStyle={isModalStyle}
                      isTask={isTask}
                      isNotRound={isNotRound}
                      variant={variant}
                      {...action}
                    />
                  </>
                );
              })}
            </ModalActions>
          )}
        </ModalContent>
      </ModalBackground>
    </ModalContainer>
  );
}
export default Modal;
